import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'plcChange';
const word = 'new PLC cost';

export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			successMessage: `The ${word} was created successfully.
				Refresh to see the new value in the list or the formula page.`,
			onSuccessRedirectTo: `/formulas/plcChanges`,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	let plcChanges;

	const canRwPlc = !!_.get(state.auth.authUser, ['permissions', 'canRwPlc'], false);

	if (state.lists.plcChangeIds) {
		plcChanges = _.map(state.lists.plcChangeIds, (id) => state.maps.plcChange[id]);
	}
	return {
		canRwPlc,
		plcChanges,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			plcChangeSearch: search,
			plcChangeAdd: add,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
